import { useTranslation } from 'react-i18next'

import { PageEmptyState } from '../../../../PageEmptyState'
import Text from '../../../../Text'

import SettingsIcon from '../../../../../icons/settings.svg'

function IntegrationsImportLogEmpty() {
  const { t } = useTranslation()

  return (
    <PageEmptyState EntityIcon={SettingsIcon}>
      <Text isSecondary>{t('RentalPortal.IntegrationsImportLogEmptyKey')}</Text>
      <Text isSecondary>
        {t('RentalPortal.IntegrationsImportLogEmptyHintKey')}
      </Text>
    </PageEmptyState>
  )
}

export default IntegrationsImportLogEmpty
